import PropTypes from "prop-types";
import { connect } from "react-redux";
import React from "react";
import { useLandingContent } from "web/react/hooks/use-landing-content/use-landing-content";
import withReduxProvider from "web/react/redux-provider";
import FeedsSeoFaq from "./feeds-seo-faq/feeds-seo-faq";
import FeedsSeoContactDetails from "./feeds-seo-contact-details/feeds-seo-contact-details";
import styles from "./feeds-seo-content.css";

function mapStateToProps(state) {
    const { visible } = state.feedSeoContentReducer;
    return {
        showContent: visible,
    };
}

function FeedsSeoProfileContents({ showContent, expandedContents }) {
    const { about_section: about, contact_details: contactDetails, faq } = expandedContents;
    const showLandingContent = useLandingContent();

    if (!showContent || !showLandingContent) {
        return null;
    }

    let aboutSection = null;

    if (about.title && about.body) {
        aboutSection = (
            <>
                <h2 className={styles.introTitle}>{about.title}</h2>
                <div
                    className={styles.introBody}
                    dangerouslySetInnerHTML={{ __html: about.body }}
                />
            </>
        );
    }

    return (
        <div className={styles.feedsSeoContent}>
            {aboutSection}
            <FeedsSeoContactDetails contactDetails={contactDetails} />
            <FeedsSeoFaq faq={faq} />
        </div>
    );
}

FeedsSeoProfileContents.propTypes = {
    showContent: PropTypes.bool,
    expandedContents: PropTypes.shape({
        about_section: PropTypes.object,
        contact_details: PropTypes.object,
        faq: PropTypes.object,
    }),
};

export default withReduxProvider(connect(mapStateToProps)(FeedsSeoProfileContents));
